
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a1679084727 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"−","E":"E","‰":"‰"},]);
Globalize.b1296697993 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"−","E":"E","‰":"‰"},]);
Globalize.a1716721341 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"−","E":"E","‰":"‰"},]);
Globalize.b1543109564 = numberParserFn([{",":"."," ":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b46488661 = pluralGeneratorFn(function(n
) {
  return (n == 1) ? 'one' : 'other';
});
Globalize.b649971929 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a411201027 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1523925384 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postadresse"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b418074927 = messageFormatterFn((function(  ) {
  return function(d) { return "Passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a393399024 = messageFormatterFn((function(  ) {
  return function(d) { return "Dette er en offentlig eller delt enhet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b917591 = messageFormatterFn((function(  ) {
  return function(d) { return "Ikke din enhet? Huker du av i denne boksen, reduseres tiden du er pålogget her før du automatisk blir logget av."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a772863876 = messageFormatterFn((function(  ) {
  return function(d) { return "Hold meg pålogget"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1057427878 = messageFormatterFn((function(  ) {
  return function(d) { return "Hvis du huker av i denne boksen, forblir du pålogget på kontoen din på denne enheten til du logger av. Ikke velg dette på delte enheter."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b621771982 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du glemt passordet?"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1381979357 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsett"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1252490480 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1459312551 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå tilbake"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b717703717 = messageFormatterFn((function(  ) {
  return function(d) { return "Last inn på nytt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1157783136 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved å logge på godtar jeg <a href=" + d["1"] + " " + d["3"] + ">vilkårene og betingelsene</a> og <a href=" + d["2"] + " " + d["4"] + ">personvernerklæringen</a> til " + d["0"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1950952766 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved å logge på godtar jeg <a href=" + d["1"] + " " + d["5"] + ">vilkårene og betingelsene</a> og <a href=" + d["2"] + " " + d["6"] + ">personvernerklæringen</a> til " + d["0"] + " samt <a href=" + d["3"] + " " + d["7"] + ">vilkårene og betingelsene for " + d["4"] + "</a>."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1567273194 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved å logge på blir jeg også med i " + d["4"] + ". Jeg godtar <a href=" + d["1"] + " " + d["5"] + ">vilkårene og betingelsene</a> og <a href=" + d["2"] + " " + d["6"] + ">personvernerklæringen</a> til " + d["0"] + " samt <a href=" + d["3"] + " " + d["7"] + ">vilkårene og betingelsene for " + d["4"] + "</a>."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a105403115 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontoen din er midlertidig utilgjengelig som følge av en rutinemessig sikkerhetskontroll. Opplysningene dine er trygge, men du må tilbakestille passordet ditt. Klikk på «Har du glemt passordet?» nedenfor for å bytte passord og logge på igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a699066015 = messageFormatterFn((function(  ) {
  return function(d) { return "E-posten og passordet stemmer ikke overens. Prøv igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2145377956 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, det oppsto en feil."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1943867106 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, det oppsto en feil. Vent litt og prøv igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1106189312 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi e-postadressen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1031091089 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi en gyldig e-post."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a102168649 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi passordet ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b815991693 = messageFormatterFn((function(  ) {
  return function(d) { return "Sjekker påloggingsopplysninger ..."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1088253710 = messageFormatterFn((function(  ) {
  return function(d) { return "Skjul passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b773911571 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a487503793 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du ikke konto? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">Lag en nå</a></span>"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b559175946 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a861629427 = messageFormatterFn((function(  ) {
  return function(d) { return "Innlogging via " + d["0"] + " er ikke lenger mulig"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1374297239 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan bruke den samme e-postadressen for å logge inn på " + d["0"] + "-kontoen din hvis du tilbakestiller passordet ditt. Dette vil ikke påvirke " + d["1"] + "-kontoen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1475864069 = messageFormatterFn((function(  ) {
  return function(d) { return "Klikk på knappen under for å tilbakestille passordet ditt. Neste gang kan du logge inn direkte på " + d["0"] + " med e-postadressen din og det nye passordet ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1713422206 = messageFormatterFn((function(  ) {
  return function(d) { return "SSO-pålogging"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b989570234 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på med automatisk pålogging"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a986011502 = messageFormatterFn((function(  ) {
  return function(d) { return "Eller bruk " + d["0"] + "-kontoen din"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1760847455 = messageFormatterFn((function(  ) {
  return function(d) { return "Samle poeng til bruk på reiser. Spar med medlemspriser. Få enkelt tilgang til reiserutene dine."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2023079355 = messageFormatterFn((function(  ) {
  return function(d) { return "Tjen " + d["0"] + " Expedia Rewards-poeng etter denne reisen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1903044168 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på " + d["0"] + "-konto"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2090328810 = messageFormatterFn((function(  ) {
  return function(d) { return "Glemt passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a239201953 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilbakestill passordet ditt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a830354277 = messageFormatterFn((function(  ) {
  return function(d) { return "Skriv inn e-postadressen din, så sender vi deg en link slik at du kan tilbakestille passordet ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1863844377 = messageFormatterFn((function(  ) {
  return function(d) { return "Send link for tilbakestilling"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1768515684 = messageFormatterFn((function(  ) {
  return function(d) { return "Sjekk e-posten din"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a167802692 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt en e-post med en link for tilbakestilling av passordet til " + d["0"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a167803653 = messageFormatterFn((function(  ) {
  return function(d) { return "Det kan ta noen minutter før du mottar e-posten. Hvis du ikke har fått e-posten etter 10 minutter, sjekk søppelpostmappen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a802515953 = messageFormatterFn((function(  ) {
  return function(d) { return "Send linken på nytt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b552394137 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt en ny link."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b835678266 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifiserer konto ..."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a163191110 = messageFormatterFn((function(  ) {
  return function(d) { return "Angi passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a217334897 = messageFormatterFn((function(  ) {
  return function(d) { return "Hyggelig å ha deg tilbake"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2071049323 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett et unikt passord for å fortsette."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2110966720 = messageFormatterFn((function(  ) {
  return function(d) { return "Sånn!"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a702782589 = messageFormatterFn((function(  ) {
  return function(d) { return "Nå kan du bruke det nye passordet for å komme i gang."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a883995944 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilbakestill passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1988858731 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, denne forespørselen har utløpt. Hvis du fortsatt må tilbakestille passordet ditt, klikk nedenfor, slik at du får tilsendt en ny e-post for tilbakestilling av passord."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1326853403 = messageFormatterFn((function(  ) {
  return function(d) { return "Send linken på nytt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b622853872 = messageFormatterFn((function(  ) {
  return function(d) { return "Lagrer passordet ditt ..."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1926671100 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett en konto"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1970477328 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett en konto"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1739491589 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postadresse"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b136770957 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi e-postadressen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1592633668 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi en gyldig e-post."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1855517338 = messageFormatterFn((function(  ) {
  return function(d) { return "Fornavn"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b793114094 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi fornavnet ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b843787772 = messageFormatterFn((function(  ) {
  return function(d) { return "Etternavn"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1344869492 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi etternavnet ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a490721797 = messageFormatterFn((function(  ) {
  return function(d) { return "Navnet må kun inneholde bokstaver."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a6594686 = messageFormatterFn((function(  ) {
  return function(d) { return "Passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b494487034 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi passordet ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2065980821 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi et gyldig passord."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1368943029 = messageFormatterFn((function(  ) {
  return function(d) { return "Består av 9−64 tegn"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1368942068 = messageFormatterFn((function(  ) {
  return function(d) { return "Inneholder både bokstaver og tall"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1368941107 = messageFormatterFn((function(  ) {
  return function(d) { return "Et spesialtegn som ~ " + "#" + " @ $ % & ! * _ ? ^ -"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1368940146 = messageFormatterFn((function(  ) {
  return function(d) { return "Passordet kan ikke inneholde mellomrom."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2021446731 = messageFormatterFn((function(  ) {
  return function(d) { return "Passordet ditt må være mellom 8 og 64 tegn."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2056282696 = messageFormatterFn((function(  ) {
  return function(d) { return "Passordet kan ikke være det samme som e-postadressen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1044893813 = messageFormatterFn((function(  ) {
  return function(d) { return "Passordet kan ikke inneholde mellomrom."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2035231635 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved å opprette en konto godtar jeg <a href=" + d["1"] + " " + d["3"] + ">vilkårene og betingelsene</a> og <a href=" + d["2"] + " " + d["4"] + ">personvernerklæringen</a> til " + d["0"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b891333355 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved å opprette en konto godtar jeg <a href=" + d["1"] + " " + d["5"] + ">vilkårene og betingelsene</a> og <a href=" + d["2"] + " " + d["6"] + ">personvernerklæringen</a> til " + d["0"] + " samt <a href=" + d["3"] + " " + d["7"] + ">vilkårene og betingelsene for " + d["4"] + "</a>."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1185224202 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg ønsker å motta reisetilbud, spesialrabatter og annen informasjon fra " + d["0"] + " på e-post."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1828513735 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg ønsker å motta reisetilbud, spesialrabatter og annen informasjon fra " + d["0"] + " på e-post. Du kan avslutte abonnementet på kampanje-e-poster når som helst."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1821960007 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg ønsker å motta ferietips, spesialtilbud og annen informasjon fra " + d["0"] + " på e-post."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1386364502 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg ønsker å motta ferietips, spesialtilbud og annen informasjon fra " + d["0"] + " på e-post. Du kan avslutte abonnementet på kampanje-e-poster når som helst."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1806648970 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsett"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1803490633 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du allerede en konto? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">Logg på</a></span>"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1011636524 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen, " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1793763570 = messageFormatterFn((function(  ) {
  return function(d) { return "Med din nye " + d["0"] + "-konto blir verden litt mindre."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b863289029 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsett"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a359648502 = messageFormatterFn((function(  ) {
  return function(d) { return "Du må ha et sterkere passord for å fortsette"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b645883589 = messageFormatterFn((function(  ) {
  return function(d) { return "Må bestå av minst 8 tegn."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b241756449 = messageFormatterFn((function(  ) {
  return function(d) { return "Passordstyrke"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a449337219 = messageFormatterFn((function(  ) {
  return function(d) { return "Svak"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a560381666 = messageFormatterFn((function(  ) {
  return function(d) { return "Sterk"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b313953736 = messageFormatterFn((function(  ) {
  return function(d) { return "Svært sterk"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b299263443 = messageFormatterFn((function(  ) {
  return function(d) { return "Unngå forutsigbare bokstaverstatninger, som @ i stedet for a."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a18716885 = messageFormatterFn((function(  ) {
  return function(d) { return "Unngå omvendt stavelse av vanlige ord."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2135556733 = messageFormatterFn((function(  ) {
  return function(d) { return "Bruk store bokstaver, men ikke for alle bokstaver."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1987784612 = messageFormatterFn((function(  ) {
  return function(d) { return "Bruk store bokstaver for mer enn bare første bokstav."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b54260296 = messageFormatterFn((function(  ) {
  return function(d) { return "Unngå datoer og årstall som har med deg å gjøre."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1776737810 = messageFormatterFn((function(  ) {
  return function(d) { return "Unngå nylige årstall."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1500804809 = messageFormatterFn((function(  ) {
  return function(d) { return "Unngå årstall som har med deg å gjøre."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1197956356 = messageFormatterFn((function(  ) {
  return function(d) { return "Unngå vanlige tegnrekker."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a382510686 = messageFormatterFn((function(  ) {
  return function(d) { return "Unngå å gjenta ord og tegn."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a616701762 = messageFormatterFn((function(  ) {
  return function(d) { return "Bruk lengre tastaturmønstre og endre skriveretning flere ganger."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a265643879 = messageFormatterFn((function(  ) {
  return function(d) { return "Legg til flere ord som er mindre vanlige."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1667419245 = messageFormatterFn((function(  ) {
  return function(d) { return "Bruk flere ord, men unngå vanlige uttrykk."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1084464822 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan opprette et sterkt passord uten å bruke tegn, tall eller store bokstaver."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a685558461 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne e-postadressen er allerede tilknyttet en konto hos " + d["0"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a268333937 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi sendte deg en link på e-post slik at du kan fullføre opprettelsen av kontoen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b153991264 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppretter konto ..."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a917120908 = messageFormatterFn((function(  ) {
  return function(d) { return "Fornavnet må bestå av minst to bokstaver"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b682925598 = messageFormatterFn((function(  ) {
  return function(d) { return "Etternavnet må bestå av minst to bokstaver"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2129796550 = messageFormatterFn((function(  ) {
  return function(d) { return "Fornavnet kan ikke være lengre enn 100 tegn."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a565124240 = messageFormatterFn((function(  ) {
  return function(d) { return "Etternavnet kan ikke være lengre enn 100 tegn."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1908342091 = messageFormatterFn((function(  ) {
  return function(d) { return "Fornavnet kan ikke inneholde spesialtegn."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1954742389 = messageFormatterFn((function(  ) {
  return function(d) { return "Etternavnet kan ikke inneholde spesialtegn."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b406120109 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg godtar alt det følgende"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a498218527 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg bekrefter at jeg har fylt 18 år, og at jeg har lest og godtar <a href=" + d["0"] + " " + d["1"] + ">betingelsene for bruk</a> og <a href=" + d["2"] + " " + d["3"] + ">vilkårene og betingelsene for " + d["4"] + "</a> (påkrevd)"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a974870147 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg godtar innsamlingen og bruken av personopplysningene mine, som beskrevet i <a href=" + d["0"] + " " + d["1"] + ">personvernerklæringen</a> (påkrevd)."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b111671702 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg godtar at personopplysningene mine kan deles med tredjeparter, enten i Sør-Korea eller utenlands, som beskrevet i <a href=" + d["0"] + " " + d["1"] + ">personvernerklæringen</a> (påkrevd)."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1821903001 = messageFormatterFn((function(  ) {
  return function(d) { return "Godta vilkårene for å fortsette."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1636023005 = messageFormatterFn((function(  ) {
  return function(d) { return "Godta vilkårene for å fortsette."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1990111455 = messageFormatterFn((function(  ) {
  return function(d) { return "Huk av i boksen for å fortsette."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1705137320 = messageFormatterFn((function(  ) {
  return function(d) { return "Eller opprett en konto hos " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1662715878 = messageFormatterFn((function(  ) {
  return function(d) { return "Unngå bruk av mellomrom, navnet ditt, e-postadressen din eller passord du har brukt før."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b460781514 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, det oppsto en feil. Vent noen minutter og prøv igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1458769564 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekreft mobilnummeret ditt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a726159757 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi sender en unik verifiseringskode til mobilnummeret ditt for å sørge for at kontoen din er trygg."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a679282810 = messageFormatterFn((function(  ) {
  return function(d) { return "Send"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a861458957 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + ". Med enerett."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b617923237 = messageFormatterFn((function(  ) {
  return function(d) { return "Vilkår og betingelser"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b451757860 = messageFormatterFn((function(  ) {
  return function(d) { return "Personvernerklæring"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1548290451 = messageFormatterFn((function(  ) {
  return function(d) { return "Send meg en SMS"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a599274952 = messageFormatterFn((function(  ) {
  return function(d) { return "Angi verifiseringskode"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a486076730 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifiseringskode"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b620952211 = messageFormatterFn((function(  ) {
  return function(d) { return "Send ny kode"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1934237438 = messageFormatterFn((function(  ) {
  return function(d) { return "Endre mobilnummer"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1868869258 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifiseringskoden har blitt sendt på nytt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2018372433 = messageFormatterFn((function(  ) {
  return function(d) { return "Angi den 6-sifrede verifiseringskoden vi nettopp sendte til " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1081055076 = messageFormatterFn((function(  ) {
  return function(d) { return "Sjekker verifiseringskode"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1391170539 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne koden er feil. Send en ny kode for å prøve igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1101193915 = messageFormatterFn((function(  ) {
  return function(d) { return "eller fortsett med"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a344981707 = messageFormatterFn((function(  ) {
  return function(d) { return "Bli medlem gratis og spar " + d["0"] + " % i snitt på tusenvis av hoteller."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1381521319 = messageFormatterFn((function(  ) {
  return function(d) { return "eller"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1678834071 = messageFormatterFn((function(  ) {
  return function(d) { return "Andre måter å logge på"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1679193485 = messageFormatterFn((function(  ) {
  return function(d) { return "Andre måter å registrere seg på"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1163883363 = messageFormatterFn((function(  ) {
  return function(d) { return "Registrer deg med Google"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1748000252 = messageFormatterFn((function(  ) {
  return function(d) { return "Kunne ikke logge på. Prøv igjen eller opprett en konto på dette nettstedet for å fortsette."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a352404214 = messageFormatterFn((function(  ) {
  return function(d) { return "Pålogging med telefonnummer er ikke tilgjengelig. Sørg for at kontoen din på sosiale medier er tilknyttet en e-postadresse og at denne kan deles."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1010932206 = messageFormatterFn((function(  ) {
  return function(d) { return "Bli medlem gratis og spar minst " + d["0"] + " % på tusenvis av hoteller."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a797337811 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på med Google"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b951952552 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på med NAVER"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b273174478 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har overskredet det maksimale antallet påloggingsforsøk. Prøv igjen senere."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1427846203 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på med biometri"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1732166459 = messageFormatterFn((function(  ) {
  return function(d) { return "Bruk biometri for å få tilgang til kontoen din uten å måtte skrive inn passord."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b124746008 = messageFormatterFn((function(  ) {
  return function(d) { return "Kom i gang"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b26751928 = messageFormatterFn((function(  ) {
  return function(d) { return "Minn meg på det senere"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b315534846 = messageFormatterFn((function(  ) {
  return function(d) { return "Sånn!"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a600531512 = messageFormatterFn((function(  ) {
  return function(d) { return "Biometrisk pålogging er nå aktivert."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1255268704 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på med biometri"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1523723291 = messageFormatterFn((function(  ) {
  return function(d) { return "Bruk passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b444107120 = messageFormatterFn((function(  ) {
  return function(d) { return "Bruk biometri"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a129291191 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppdater passordet ditt for å fortsette"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b480698203 = messageFormatterFn((function(  ) {
  return function(d) { return "For å få tilgang til kontoen din må du tilbakestille passordet."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1639324485 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilbakestill passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1189892709 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen til medlemsfordeler"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b667490431 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi gir deg poeng til en verdi av $" + d["0"] + " som du kan bruke på din neste reise!"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1205866959 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan se poengene direkte på kontoen din og bruke dem på den første bestillingen din via alternativet for bruk av poeng på betalingssiden."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a739291325 = messageFormatterFn((function(  ) {
  return function(d) { return "Du er nå Expedia-medlem."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1866428435 = messageFormatterFn((function(  ) {
  return function(d) { return "Spar med det samme med medlemspriser, og tjen poeng når du bestiller. "; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b450173944 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på eller lag en konto"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a304363986 = messageFormatterFn((function(  ) {
  return function(d) { return "Bli medlem gratis og spar " + d["0"] + " % i snitt på tusenvis av hoteller."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1268353360 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved å fortsette bekrefter du at du har lest og godtar våre <a href=" + d["1"] + " " + d["3"] + ">vilkår og betingelser</a> og vår <a href=" + d["2"] + " " + d["4"] + ">personvernerklæring</a>."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1041451086 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved å fortsette bekrefter du at du har lest og godtar våre <a href=" + d["1"] + " " + d["5"] + ">vilkår og betingelser</a>, vår <a href=" + d["2"] + " " + d["6"] + ">personvernerklæring</a> og <a href=" + d["3"] + " " + d["7"] + ">vilkårene og betingelsene for " + d["4"] + "</a>."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1866698035 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved å fortsette bekrefter du at du har lest og godtar våre <a href=" + d["1"] + " " + d["4"] + ">vilkår og betingelser</a>, vår <a href=" + d["2"] + " " + d["5"] + ">personvernerklæring</a> og <a href=" + d["3"] + " " + d["6"] + ">vilkårene og betingelsene for bonusordningen One Key</a>."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1394880201 = messageFormatterFn((function(  ) {
  return function(d) { return "E-post"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1570618191 = messageFormatterFn((function(  ) {
  return function(d) { return "Angi en gyldig e-postadresse"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a429075316 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1733052223 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b155236779 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1101410738 = messageFormatterFn((function(  ) {
  return function(d) { return "Dette er kun for personlige enheter. For å beskytte kontoen din må du ikke huke av her hvis du bruker en delt enhet."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1477505985 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har forsøkt å logge på for mange ganger. Du må vente i " + d["0"] + " minutter før du prøver igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b377885949 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har forsøkt å logge på for mange ganger. Du må vente i " + d["0"] + " minutt før du prøver igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b372990615 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har forsøkt å logge på for mange ganger. Du må vente i " + d["0"] + " minutter før du prøver igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b386448459 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har forsøkt å logge på for mange ganger. Du må vente i " + d["0"] + " minutter før du prøver igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1101523384 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har forsøkt å logge på for mange ganger. Du må vente i " + d["0"] + " minutter før du prøver igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2100385965 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har forsøkt å logge på for mange ganger. Du må vente i " + d["0"] + " minutter før du prøver igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b305552548 = messageFormatterFn((function(  ) {
  return function(d) { return "Få tilgang til en verden av fordeler med én konto på tvers av Expedia, Hotels.com og Vrbo."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1620566620 = messageFormatterFn((function(  ) {
  return function(d) { return "Få tilgang til en verden av reiser med én konto på tvers av Expedia, Hotels.com og Vrbo."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a488449891 = messageFormatterFn((function(  ) {
  return function(d) { return "Søk etter og lagre overnattingssteder, planlegg sammen med andre og se bestillingsopplysningene dine."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b706725662 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontoen din er midlertidig utilgjengelig som følge av en rutinemessig sikkerhetskontroll. Opplysningene dine er trygge, men du må tilbakestille passordet ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1388156338 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på og bestill for å tjene OneKeyCash"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b812645050 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi må bekrefte at det er deg"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b524572716 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi den sikre koden vi har sendt deg på e-post. Sjekk søppelpostmappen hvis du ikke finner den i innboksen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1061870312 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekreft e-postadressen din"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a804101826 = messageFormatterFn((function(  ) {
  return function(d) { return "For å fortsette må du oppgi den sikre koden vi har sendt til " + d["0"] + ". Sjekk søppelpostmappen hvis du ikke finner den i innboksen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1615022980 = messageFormatterFn((function(  ) {
  return function(d) { return "6-sifret kode"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a247139076 = messageFormatterFn((function(  ) {
  return function(d) { return "Send ny kode"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b415655333 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a276614749 = messageFormatterFn((function(  ) {
  return function(d) { return "Send ny kode innen 00:" + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1264404627 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du ikke fått e-posten?"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1002581941 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan be om en ny kode om " + d["0"] + " sek"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b20599618 = messageFormatterFn((function(  ) {
  return function(d) { return "Be om en ny sikker kode"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a272197704 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt en 6-sifret kode til innboksen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b766195949 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi passord i stedet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b284028786 = messageFormatterFn((function(  ) {
  return function(d) { return "Ugyldig kode, prøv på nytt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1392527428 = messageFormatterFn((function(  ) {
  return function(d) { return "Koden har utløpt, send nye kode og prøv på nytt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a368900529 = messageFormatterFn((function(  ) {
  return function(d) { return "Sjekk søppelpostmappen hvis du ikke finner den i innboksen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1602889128 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har oppdatert brukeropplevelsen og må bekrefte e-postadressen din. Oppgi den sikre koden vi har sendt til innboksen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1662192217 = messageFormatterFn((function(  ) {
  return function(d) { return "Det oppsto en feil. Prøv igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a347329392 = messageFormatterFn((function(  ) {
  return function(d) { return "For å oppdatere påloggingsmetoden din må du oppgi den sikre koden vi har sendt deg på e-post."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1753783318 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi passordet ditt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1818266703 = messageFormatterFn((function(  ) {
  return function(d) { return "Send en sikkerhetskode via e-post"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b427530703 = messageFormatterFn((function(  ) {
  return function(d) { return "E-posten og passordet stemmer ikke overens"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1696356858 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett et passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a38913380 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett et passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2119202058 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan bruke samme e-postadresse og passord til å logge på Expedia, Hotels.com og Vrbo."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1240807830 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a437004147 = messageFormatterFn((function(  ) {
  return function(d) { return "Angi et passord du kan bruke i tillegg til andre sikre påloggingsmetoder."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b821437272 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett et nytt passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1494657902 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett et nytt passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1120830728 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan nå bruke én konto til å logge på Expedia, Hotels.com og Vrbo. Opprett et nytt, sikkert passord for din kombinerte konto."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1775876888 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b922077104 = messageFormatterFn((function(  ) {
  return function(d) { return "Endre passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b260230560 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg et unikt og sterkt passord."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a70774464 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppdater passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1565991981 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kunne ikke endre passordet ditt. Prøv igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b796802421 = messageFormatterFn((function(  ) {
  return function(d) { return "Glemt passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1003214737 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi e-posten din, så sender vi deg en sikker kode slik at du kan logge på."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2090601041 = messageFormatterFn((function(  ) {
  return function(d) { return "Send e-post"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a456790301 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontakt oss"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1853600114 = messageFormatterFn((function(  ) {
  return function(d) { return "Slett konto"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1673240025 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1522493237 = messageFormatterFn((function(  ) {
  return function(d) { return "Vent mens vi sjekker kontoen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b231778028 = messageFormatterFn((function(  ) {
  return function(d) { return "Slett konto"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1617825912 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1969937356 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan ikke slette kontoen din før reisen din er avsluttet."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a759369581 = messageFormatterFn((function(  ) {
  return function(d) { return "Du behøver kontoen for å få tilgang til bestillingen din og få hjelp fra kundeservice hvis det oppstår endringer i siste liten."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1947513030 = messageFormatterFn((function(  ) {
  return function(d) { return "Du må først slette utleierkontoen din hos Vrbo."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2020846735 = messageFormatterFn((function(  ) {
  return function(d) { return "Besøk hjelpesidene våre på nettstedet eller i appen for å kontakte vår kundeservice og sette i gang prosessen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1078883039 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igjen etter at reisen din er avsluttet."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1725547582 = messageFormatterFn((function(  ) {
  return function(d) { return "Hvorfor vil du slette kontoen din?"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a223330065 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg mottar for mange e-poster eller varsler"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b344131929 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg har en annen " + d["0"] + "-konto"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1865339358 = messageFormatterFn((function(  ) {
  return function(d) { return "Reisen min er over, så jeg behøver ikke denne kontoen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1470320616 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg hadde en negativ bestillingsopplevelse med " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2056911287 = messageFormatterFn((function(  ) {
  return function(d) { return "Annet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a459424806 = messageFormatterFn((function(  ) {
  return function(d) { return "Hopp over"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1356272429 = messageFormatterFn((function(  ) {
  return function(d) { return "Send inn"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a790475709 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi er lei for at du forlater oss. Du må være klar over følgende:"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1163790832 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste " + d["0"] + " Expedia Rewards-poeng til en verdi av " + d["1"] + ", tilgodebeløp til en verdi av " + d["2"] + ", kuponger, lagrede reiseelementer og kontopreferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a381581633 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste " + d["0"] + " Expedia Rewards-poeng til en verdi av " + d["1"] + ", kuponger, lagrede reiseelementer og kontopreferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1597137661 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste reisetavler, tilgodebeløp og preferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1965264121 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards: Du vil miste " + d["0"] + " bonusovernattinger til en verdi av " + d["1"] + " og " + d["2"] + " stempler til en gjennomsnittsverdi på " + d["3"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a60208586 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste tilgodebeløp, kuponger, lagrede reiseelementer og kontopreferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1544299150 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste " + d["0"] + " CheapCash til en verdi av " + d["1"] + ", tilgodebeløp til en verdi av " + d["2"] + ", kuponger, lagrede reiseelementer og kontopreferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1936932737 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste " + d["0"] + " CheapCash til en verdi av " + d["1"] + ", kuponger, lagrede reiseelementer og kontopreferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b863807254 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste " + d["0"] + " Orbucks til en verdi av " + d["1"] + ", tilgodebeløp til en verdi av " + d["2"] + ", kuponger, lagrede reiseelementer og kontopreferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1168643577 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste " + d["0"] + " Orbucks til en verdi av " + d["1"] + ", kuponger, lagrede reiseelementer og kontopreferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1657058448 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste " + d["0"] + " MrJet Rewards til en verdi av " + d["1"] + ", tilgodebeløp til en verdi av " + d["2"] + ", kuponger, lagrede reiseelementer og kontopreferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a378619841 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste " + d["0"] + " MrJet Rewards til en verdi av " + d["1"] + ", kuponger, lagrede reiseelementer og kontopreferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1566654354 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste " + d["0"] + " BONUS+ til en verdi av " + d["1"] + ", tilgodebeløp til en verdi av " + d["2"] + ", kuponger, lagrede reiseelementer og kontopreferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1803367841 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste " + d["0"] + " BONUS+ til en verdi av " + d["1"] + ", kuponger, lagrede reiseelementer og kontopreferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b680190436 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste kuponger, lagrede reiseelementer og kontopreferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1091180081 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste tilgodebeløp til en verdi av " + d["0"] + ", kuponger, lagrede reiseelementer og kontopreferanser for alltid."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b775683483 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan oppbevare visse opplysninger på en trygg måte, for eksempel transaksjonshistorikken din, for å oppfylle juridiske forpliktelser eller for å påvise, utøve eller forsvare et rettslig krav. Disse opplysningene vil bli oppbevart på en sikker måte og deretter slettet, anonymisert eller permanent skjult når de ikke lenger er nødvendige."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1636444711 = messageFormatterFn((function(  ) {
  return function(d) { return "Slett kontoen permanent"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a132108073 = messageFormatterFn((function(  ) {
  return function(d) { return "Ikke slett kontoen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2128541727 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi håper vi sees igjen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1440652544 = messageFormatterFn((function(  ) {
  return function(d) { return "Det kan ta noen uker å behandle forespørselen din om sletting, og du kan fortsette å motta kommunikasjon til systemet vårt er oppdatert."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1401575450 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igjen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a895464391 = messageFormatterFn((function(  ) {
  return function(d) { return "Det oppsto en systemfeil. Bekreft slettingen av kontoen din på nytt, eller prøv igjen om noen minutter."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a252693071 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b603124888 = messageFormatterFn((function(  ) {
  return function(d) { return "Hva er navnet i reisedokumentet ditt?"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1457208936 = messageFormatterFn((function(  ) {
  return function(d) { return "Bruk samme navn på kontoen din som i passet eller ID-kortet ditt. Vi har det klart neste gang du bestiller."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1673899478 = messageFormatterFn((function(  ) {
  return function(d) { return "Motta tilbud og annen informasjon fra " + d["0"] + " på e-post."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a930979929 = messageFormatterFn((function(  ) {
  return function(d) { return "Motta tilbud og annen informasjon fra " + d["0"] + " på e-post. Du kan avslutte abonnementet på markedsførings-e-post når som helst."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2034968596 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontoinformasjon"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b772347286 = messageFormatterFn((function(  ) {
  return function(d) { return "Få e-poster om tilbud og med nyttig informasjon fra " + d["0"] + ". Du kan avslutte abonnementet når som helst."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b483399738 = messageFormatterFn((function(  ) {
  return function(d) { return "Hold deg oppdatert"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a79815648 = messageFormatterFn((function(  ) {
  return function(d) { return "Samtykke til markedsføring"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1149662831 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a31877203 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1972641653 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1128686323 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1078119343 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a856429722 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1560879858 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1304057633 = messageFormatterFn((function(  ) {
  return function(d) { return "Du må vente til reisen din er fullført"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a783838417 = messageFormatterFn((function(  ) {
  return function(d) { return "Du må vente til de kommende reisene dine er fullført"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1383676791 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontoen din gir deg tilgang til bestillingsopplysninger og support hvis du skulle trenge det. Prøv igjen etter at reisen din er avsluttet."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b665299973 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontoen din gir deg tilgang til bestillingsopplysninger og hjelp hvis du skulle trenge det. Prøv igjen etter at reisene dine er avsluttet."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2036327412 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontoen din kan ikke slettes på nåværende tidspunkt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1430250210 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne kontoen brukes også til å leie ut overnattingssteder på Vrbo. Før du kan slette kontoen din, må du logge på Vrbo Owner-appen eller -nettstedet og fjerne de aktive annonsene dine."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1922239535 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi vil gjerne vite hvorfor du sletter kontoen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1976628090 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg har en konto med en annen e-postadresse"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a646289403 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg har hatt en negativ bestillingsopplevelse"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a116983824 = messageFormatterFn((function(  ) {
  return function(d) { return "Det er synd at du forlater oss. Vær oppmerksom på at det ikke er mulig å gjenopprette en slettet konto, og at slettingen vil påvirke dataene dine hos Expedia, Hotels.com og Vrbo. Du må være klar over følgende:"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1436242725 = messageFormatterFn((function(  ) {
  return function(d) { return "Det er synd at du forlater oss. Vær oppmerksom på at det ikke er mulig å gjenopprette en slettet konto, og at slettingen vil påvirke dataene dine hos Expedia, Wotif, Hotels.com og Vrbo. Du må være klar over følgende:"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1751582036 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister kontohistorikken din, innstillingene dine og lagrede elementer på både Expedia, Hotels.com og Vrbo for godt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b401393033 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister kontohistorikken din, innstillingene dine og lagrede elementer på Expedia, Wotif, Hotels.com og Vrbo for godt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a819486304 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister alle OneKeyCash, inkludert utestående OneKeyCash, og medlemsnivået ditt i One Key med alle fordeler for godt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1988994902 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister alle utestående OneKeyCash og medlemsnivået ditt i One Key med alle fordeler for godt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a257084373 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil miste " + d["0"] + " i OneKeyCash, utestående OneKeyCash og medlemsnivået ditt i One Key med alle fordeler for godt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1484085281 = messageFormatterFn((function(  ) {
  return function(d) { return "Innehavere av Hotels.com Rewards-kredittkort får ikke lenger fordeler basert på kortaktivitet."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b44086466 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister alle Expedia Rewards-poeng, inkludert alle bekreftede og utestående Expedia Rewards-poeng, Hotels.com-stempler og -bonusovernattinger samt medlemsnivået ditt for godt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1689987380 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister alle Expedia Rewards-poeng, Hotels.com-stempler og -bonusovernattinger samt medlemsnivået ditt for godt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1648422022 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister alle kuponger og tilgodebeløp for Expedia, Hotels.com og Vrbo for godt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1619722437 = messageFormatterFn((function(  ) {
  return function(d) { return "Du mister alle kuponger og tilgodebeløp for Expedia, Wotif, Hotels.com og Vrbo for godt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a780073235 = messageFormatterFn((function(  ) {
  return function(d) { return "Det kan ta noen uker å behandle forespørselen om sletting av Expedia-, Hotels.com- eller Vrbo-kontoen din, så det kan hende at du fortsetter å motta kommunikasjon frem til systemet vårt er oppdatert."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1230729314 = messageFormatterFn((function(  ) {
  return function(d) { return "Det kan ta noen uker å behandle forespørselen om sletting av Expedia-, Wotif-, Hotels.com- eller Vrbo-kontoen din, så det kan hende at du fortsetter å motta kommunikasjon frem til systemet vårt er oppdatert."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a946343496 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt One Key Card blir stengt når du sletter kontoen din, og du vil ikke lenger tjene OneKeyCash på kjøpene dine. Wells Fargo vil kontakte deg for å bekrefte stengningen av kortet ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b99669278 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt One Key+ Card blir stengt når du sletter kontoen din, og du vil ikke lenger tjene OneKeyCash på kjøpene dine. Wells Fargo vil kontakte deg for å bekrefte stengningen av kortet ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b321774711 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på eller lag en konto for å tjene OneKeyCash for reisen din"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b495257999 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på eller lag en konto for å samle fordeler for dette oppholdet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a803943752 = messageFormatterFn((function(  ) {
  return function(d) { return "Bestill som gjest"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1122202182 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på " + d["0"] + "-konto: Legg til mobilnummer"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1623643178 = messageFormatterFn((function(  ) {
  return function(d) { return "Det oppsto en feil"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1704162268 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv å logge på igjen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a309377107 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1834304763 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.a1346116165 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b719399976 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b1841853934 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.a1400257189 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a2029270490 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b1096988091 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.a1454398213 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.a1983892485 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b960971368 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a681837221 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b1243355590 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"S","mon":"M","tue":"T","wed":"O","thu":"T","fri":"F","sat":"L"}}}});
Globalize.b1287065083 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"søndag","mon":"mandag","tue":"tirsdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lørdag"}}}});
Globalize.a1754656773 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januar","2":"februar","3":"mars","4":"april","5":"mai","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"desember"}}}});
Globalize.a1729878779 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a12324408 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"2":Globalize("nb-NO").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.b899932791 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"mai","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"des."}}}});
Globalize.b2147473888 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januar","2":"februar","3":"mars","4":"april","5":"mai","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"desember"}}}});
Globalize.b90159979 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januar","2":"februar","3":"mars","4":"april","5":"mai","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"desember"}}}});
Globalize.a1521051627 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januar","2":"februar","3":"mars","4":"april","5":"mai","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"desember"}}}});
Globalize.a1521736820 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM y","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"mai","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"des."}}}});
Globalize.a588400969 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"EEEE d. MMM","timeSeparator":":","days":{"E":{"4":{"sun":"søndag","mon":"mandag","tue":"tirsdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lørdag"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"mai","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"des."}}}});
Globalize.a2140105240 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"E d. MMM","timeSeparator":":","days":{"E":{"1":{"sun":"søn.","mon":"man.","tue":"tir.","wed":"ons.","thu":"tor.","fri":"fre.","sat":"lør."}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"mai","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"des."}}}});
Globalize.b1455591012 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a1724829916 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a1095517231 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b26936727 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a1778970940 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b450779599 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.b718274340 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a1833111964 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b1932361060 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a853945839 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a1060550972 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b1394528957 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b2123225636 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a918496220 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b1981804924 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"d"}));
Globalize.b379082673 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.b472074222 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b1768760137 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b1234935586 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a1899765378 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a1900450571 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b29329582 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b1776148305 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a158470731 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b956075637 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a306136222 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b816317736 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b901934613 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b1240160608 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a895787403 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.b847793589 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b318299317 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a64564830 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b1620354581 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a411605812 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^T/],["wed",/^O/],["thu",/^T/],["fri",/^F/],["sat",/^L/]]});
Globalize.a1260172747 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["tue",/^tirsdag/],["thu",/^torsdag/],["sun",/^søndag/],["mon",/^mandag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lørdag/]]});
Globalize.a6927307 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^desember/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^mai/]]});
Globalize.a755375349 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b223479682 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.a826918275 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^des\./],["5",/^mai/]]});
Globalize.b154698394 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^desember/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^mai/]]});
Globalize.a1556338191 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^desember/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^mai/]]});
Globalize.b781140175 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^desember/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^mai/]]});
Globalize.b780454982 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^des\./],["5",/^mai/]]});
Globalize.b1969789885 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE d. MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["tue",/^tirsdag/],["thu",/^torsdag/],["sun",/^søndag/],["mon",/^mandag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lørdag/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^des\./],["5",/^mai/]]});
Globalize.b162086562 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d. MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^søn\./],["mon",/^man\./],["tue",/^tir\./],["wed",/^ons\./],["thu",/^tor\./],["fri",/^fre\./],["sat",/^lør\./]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^des\./],["5",/^mai/]]});
module.exports = Globalize;
